import { Routes } from '@angular/router';
import { LayoutComponent } from '../layout/layout.component';

import { LoginComponent } from './pages/login/login.component';
import { RecoverComponent } from './pages/recover/recover.component';
import { MaintenanceComponent } from './pages/maintenance/maintenance.component';
import { Error404Component } from './pages/error404/error404.component';
import { ForgotComponent } from './pages/forgot/forgot.component';
import { MsalGuard } from '@azure/msal-angular';
import { FailedComponent } from './pages/failed/failed.component';
import { ProfileComponent } from './pages/profile/profile.component';

export const routes: Routes = [

    {
        path: 'azure-login',
        component: ProfileComponent
      },
      {
        path: 'login-failed',
        component: FailedComponent
      },

    {
        path: '',
        component: LayoutComponent,
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
            { path: 'utenti', loadChildren: () => import('./utenti/utenti.module').then(m => m.UtentiModule) },
            { path: 'menu', loadChildren: () => import('./menu/menu.module').then(m => m.MenuModule) },
            { path: 'assistenze', loadChildren: () => import('./assistenza/assistenza.module').then(m => m.AssistenzaModule) },
            { path: 'richieste-conferma', loadChildren: () => import('./richiesta/richiesta.module').then(m => m.RichiestaModule) },
            { path: 'fondi-stazione', loadChildren: () => import('./fondo-stazione/fondo-stazione.module').then(m => m.FondoStazioneModule) },
            { path: 'esportazioni', loadChildren: () => import('./esportazioni/esportazioni.module').then(m => m.EsportazioniModule) },
            { path: 'tratte', loadChildren: () => import('./tratta/tratta.module').then(m => m.TrattaModule) },
            { path: 'stazioni', loadChildren: () => import('./stazione/stazione.module').then(m => m.StazioneModule) },
            { path: 'listini', loadChildren: () => import('./listino/listino.module').then(m => m.ListinoModule) },
            { path: 'distanze', loadChildren: () => import('./distanza/distanza.module').then(m => m.DistanzaModule) },
            //{ path: 'allegato', loadChildren: () => import('./allegato/allegato.module').then(m => m.AllegatoModule)},
        ]
    },

    // Not lazy-loaded routes
    { path: 'login', component: LoginComponent },
    { path: 'login/:id', component: LoginComponent }, 
    { path: 'recover/:token', component: RecoverComponent },
    { path: 'forgot', component: ForgotComponent },
    { path: 'maintenance', component: MaintenanceComponent },
    { path: '404', component: Error404Component },

    // Not found
    { path: '**', redirectTo: 'home' }

];
